import { render, staticRenderFns } from "./ActivityDraggableTextButtons.vue?vue&type=template&id=71225ccd&scoped=true"
import script from "./ActivityDraggableTextButtons.vue?vue&type=script&lang=ts"
export * from "./ActivityDraggableTextButtons.vue?vue&type=script&lang=ts"
import style0 from "./ActivityDraggableTextButtons.vue?vue&type=style&index=0&id=71225ccd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71225ccd",
  null
  
)

/* custom blocks */
import block0 from "./ActivityDraggableTextButtons.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports